import { BooleanInput, Edit, SimpleForm, TextInput } from 'react-admin';

const jsonFormat = (value: unknown) => (value && typeof value === 'object' ? JSON.stringify(value, null, 2) : (value as string) ?? '');
const jsonParse = (value: string) => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

const emptyStringToNull = (value: unknown) => (value === '' || value === undefined ? null : value);

const validateExtraOptionsOptional = (value: unknown): string | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }
  if (typeof value === 'object' && !Array.isArray(value)) {
    return undefined;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') {
      return undefined;
    }
    try {
      const parsed = JSON.parse(trimmed) as unknown;
      if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
        return 'Must be a JSON object';
      }
      return undefined;
    } catch {
      return 'Invalid JSON';
    }
  }
  return 'Must be a JSON object';
};

const CountryConfigsEdit = () => (
  <Edit redirect="list">
    <SimpleForm>
      <TextInput disabled source="uuid" label="UUID" />
      <TextInput disabled source="country" label="Country code" />
      <TextInput source="cssUrl" label="CSS URL" fullWidth parse={emptyStringToNull} helperText="Optional" />
      <TextInput source="payrollUrl" label="Payroll URL" fullWidth parse={emptyStringToNull} helperText="Optional" />
      <TextInput source="payrollUrlAuthStrategy" label="Payroll URL Auth Strategy" parse={emptyStringToNull} helperText="Optional" />
      <BooleanInput source="monthlyAccrualEnabled" label="Monthly accrual enabled" helperText="Persists under extra_options.settings.monthlyAccrualEnabled" />
      <TextInput source="extraOptions" label="Extra Options (JSON)" multiline fullWidth minRows={8} format={jsonFormat} parse={jsonParse} validate={validateExtraOptionsOptional} helperText="Optional — valid JSON object (e.g. {})" />
    </SimpleForm>
  </Edit>
);

export default CountryConfigsEdit;
